export default "<div>Logging out, please wait...</div>\r\n";